define(["exports", "../core/defaults", "../core/dfn-map", "../core/linter", "../core/linter-rules/privsec-section"], function (_exports, _defaults, _dfnMap, _linter, _privsecSection) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _linter = _interopRequireDefault(_linter);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  // @ts-check

  /**
   * Sets the defaults for W3C specs
   */
  const name = "w3c/defaults";
  _exports.name = name;

  _linter.default.register(_privsecSection.rule);

  const w3cDefaults = {
    lint: {
      "privsec-section": true
    },
    pluralize: true,
    doJsonLd: false,
    license: "w3c-software-doc",
    logos: [{
      src: "https://www.w3.org/StyleSheets/TR/2016/logos/W3C",
      alt: "W3C",
      height: 48,
      width: 72,
      url: "https://www.w3.org/"
    }],
    xref: true
  };

  function run(conf) {
    if (conf.specStatus === "unofficial") return; // assign the defaults

    const lint = conf.lint === false ? false : _objectSpread({}, _defaults.coreDefaults.lint, {}, w3cDefaults.lint, {}, conf.lint);
    Object.assign(conf, _objectSpread({}, _defaults.coreDefaults, {}, w3cDefaults, {}, conf, {
      lint
    })); // TODO: eventually, we want to remove this.
    // It's here for legacy support of json-ld specs
    // see https://github.com/w3c/respec/issues/2019

    Object.assign(conf, {
      definitionMap: _dfnMap.definitionMap
    });
  }
});
//# sourceMappingURL=defaults.js.map